<div id="content">
    <router-outlet></router-outlet>
</div>
